var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.800781,
    height: 21.599976,
    viewBox: "0 0 19.8008 21.6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M7.92 0C7.64 -0.01 7.41 0.08 7.21 0.27C7.01 0.45 6.91 0.67 6.91 0.93L1 0.93C0.72 0.93 0.49 1.02 0.29 1.2C0.09 1.39 0 1.61 0 1.87C0 2.14 0.09 2.36 0.29 2.54C0.49 2.73 0.72 2.82 1 2.81L18.79 2.81C19.07 2.82 19.3 2.73 19.5 2.54C19.7 2.36 19.8 2.14 19.8 1.87C19.8 1.61 19.7 1.39 19.5 1.2C19.3 1.02 19.07 0.93 18.79 0.93L12.87 0.93C12.87 0.67 12.78 0.45 12.58 0.27C12.38 0.08 12.15 -0.01 11.87 0L7.92 0ZM1 4.69L1 19.72C1 20.75 1.88 21.6 2.98 21.6L16.82 21.6C17.91 21.6 18.79 20.75 18.79 19.72L18.79 4.69L1 4.69Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyDelete);
export default __webpack_public_path__ + "static/media/notify_delete.719497085d3d982eec7494996deac5b8.svg";
export { ForwardRef as ReactComponent };